<template>
  <div>
    <v-btn
      :disabled="isDisabled"
      class="mb-4"
      color="primary"
      @click="copy"
      text
    >
      <v-icon>
        mdi-content-copy
      </v-icon>
      Copy
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    copied: false,
  }),
  methods: {
    copy() {
      navigator.clipboard.writeText(this.content)
      this.copied = true
      setTimeout(() => this.copied = false, 1000)
    },

  }, 
  computed: {
    isDisabled() {
      return this.content.length === 0
    }
  }
}
</script>

